<template>
  <div>
    <TopHeader2></TopHeader2>
    <main class="main">
      <PagesPath :items="[' تماس با ما']" :last="'/contact'"></PagesPath>
      <section
        v-if="homeData"
        class="contact container marginTop box-shaddow20 border-radius10 mt-md-0 mt-5 p-3"
      >
        <h5 class="weight-bold text-color-444 text-right">اطلاعات تماس</h5>
        <p class="line-height2 text-color-666 fontsize14 text-justify">
          {{ homeData.settings.contact_body1 }}
        </p>

        <form @submit.prevent="send()">
          <div class="contact-grid fontsize14">
            <input
              v-model="name"
              class="bg-color-eai border-radius10 border p-3"
              type="text"
              placeholder="نام:"
            />
            <input
              v-model="email"
              class="bg-color-eai border-radius10 border p-3"
              type="text"
              placeholder="ایمیل:"
            />
            <input
              v-model="subject"
              class="bg-color-eai border-radius10 border p-3"
              type="text"
              placeholder="موضوع:"
            />
          </div>
          <textarea
            v-model="body"
            class="bg-color-eai border-radius10 border p-3 w-100 mt-3"
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="پیام:"
          ></textarea>
          <div
            class="d-flex justify-content-between align-items-baseline mt-3 fontsize14"
          >
            <div class="contact-text ml-2">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.9999 2.75021C17.1089 2.75021 21.2499 6.89221 21.2499 12.0002C21.2499 17.1082 17.1089 21.2502 11.9999 21.2502C6.89188 21.2502 2.74988 17.1082 2.74988 12.0002C2.74988 6.89221 6.89188 2.75021 11.9999 2.75021Z"
                  stroke="#999"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.995 8.20432V12.6233"
                  stroke="#999"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.995 15.7961H12.005"
                  stroke="#999"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span
                :class="{ error: messageStatus == 'error' }"
                class="fontsize13 text-color-999 mr-1"
              >
                {{ messageText }}
              </span>
            </div>
            <input
              class="w-25 bg-btn-hover bg-color-theme border-radius10 p-3 text-white"
              type="submit"
              value="ارسال پیام"
            />
          </div>
        </form>
        <section
          class="contact-info text-color-444 p-md-4 p-3 mt-3 mb-5 border-radius10 text-right"
        >
          <section class="border-radius15 mb-3">
            <h5 class="weight-bold">اطلاعات تماس</h5>
            <p class="line-height2 fontsize14 text-justify">
              {{ homeData.settings.contact_body2 }}
            </p>
          </section>

          <div
            class="p-3 mb-2 fontsize15 border-radius10 d-flex flex-wrap justify-content-between align-items-baseline weight-bold"
          >
            <div>
              <span class="weight-heavy">شماره تماس های ما</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="currentColor"
                class="bi bi-chevron-double-left mt-n1 mr-1"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#444"
                  fill-rule="evenodd"
                  d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
                <path
                  fill="#444"
                  fill-rule="evenodd"
                  d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </div>
            <div class="">
              <span class="ml-2 fontsize-mini weight-bold">{{
                homeData.settings.contact_phone
              }}</span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.99033 4.87254C3.30665 4.34878 5.0495 2.44376 6.29322 2.50127C6.665 2.53208 6.99364 2.75699 7.26067 3.01784C7.87379 3.61656 9.62897 5.88101 9.72859 6.35753C9.97096 7.52621 8.57833 8.1999 9.00454 9.37783C10.0911 12.0366 11.9634 13.9088 14.6233 14.9943C15.8003 15.4205 16.474 14.0279 17.6428 14.2713C18.1183 14.3709 20.3839 16.126 20.9826 16.7391C21.2425 17.0051 21.4684 17.3347 21.4992 17.7065C21.5454 19.0159 19.5222 20.7833 19.1278 21.0092C18.1974 21.6747 16.9834 21.6634 15.5035 20.9753C11.3739 19.2572 4.77426 12.7822 3.02422 8.49669C2.35461 7.02505 2.30839 5.80297 2.99033 4.87254Z"
                  stroke="#444"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            class="p-3 mb-2 fontsize15 border-radius10 d-flex flex-wrap justify-content-between align-items-baseline weight-bold"
          >
            <div>
              <span class="weight-heavy">ایمیل های ارتباطی</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="currentColor"
                class="bi bi-chevron-double-left mr-1"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#444"
                  fill-rule="evenodd"
                  d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
                <path
                  fill="#444"
                  fill-rule="evenodd"
                  d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </div>
            <div class="">
              <span class="ml-2 fontsize-mini weight-bold">{{
                homeData.settings.contact_email
              }}</span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.2677 9.06113L13.0023 12.4954C12.1951 13.1283 11.0635 13.1283 10.2563 12.4954L5.95424 9.06113"
                  stroke="#444"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.88787 3.5H16.3158C17.6752 3.51525 18.969 4.08993 19.896 5.0902C20.823 6.09048 21.3022 7.42903 21.222 8.79412V15.322C21.3022 16.6871 20.823 18.0256 19.896 19.0259C18.969 20.0262 17.6752 20.6009 16.3158 20.6161H6.88787C3.96796 20.6161 2 18.2407 2 15.322V8.79412C2 5.87545 3.96796 3.5 6.88787 3.5Z"
                  stroke="#444"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
          <div
            class="p-3 fontsize15 border-radius10 d-flex flex-wrap justify-content-between align-items-baseline weight-bold"
          >
            <div>
              <span class="weight-heavy"> آدرس دفترمرکزی </span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="currentColor"
                class="bi bi-chevron-double-left mr-1"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
                <path
                  fill-rule="evenodd"
                  d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                />
              </svg>
            </div>
            <div class="">
              <span class="ml-2 fontsize-mini weight-bold">{{
                homeData.settings.contact_address
              }}</span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.23913 10.3913C4.25354 6.15071 7.70289 2.72471 11.9435 2.73912C16.1841 2.75353 19.6101 6.20288 19.5957 10.4435V10.5304C19.5435 13.2869 18.0043 15.8348 16.1174 17.8261C15.0382 18.9467 13.8331 19.9388 12.5261 20.7826C12.1766 21.0849 11.6582 21.0849 11.3087 20.7826C9.3602 19.5143 7.65007 17.9131 6.25652 16.0522C5.01448 14.4294 4.3093 12.4597 4.23913 10.4174L4.23913 10.3913Z"
                  stroke="#444"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle
                  cx="11.9174"
                  cy="10.5391"
                  r="2.46087"
                  stroke="#444"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </section>
      </section>
    </main>
  </div>
</template>

<script>
import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
export default {
  name: "Contact",
  components: {
    TopHeader2,
    PagesPath
  },
  data() {
    return {
      blog: null,
      blogComment: null,
      name: "",
      email: "",
      subject: "",
      body: "",
      messageStatus: "success",
      messageText: "پیام شما بلافاصله پس از دریافت پاسخ داده خواهد شد"
    };
  },
  methods: {
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    send() {
      if (this.name.length < 5) {
        this.messageStatus = "error";
        const options = { title: "توجه", size: "sm" };
        this.$dialogs.alert("نام خود را به صورت کامل وارد کنید", options);
        return (this.messageText = "نام خود را به صورت کامل وارد کنید");
      } else if (!this.validateEmail(this.email)) {
        this.messageStatus = "error";
        const options = { title: "توجه", size: "sm" };
        this.$dialogs.alert("ایمیل خود را با فرمت درست وارد کنید", options);
        return (this.messageText = "ایمیل خود را با فرمت درست وارد کنید");
      } else if (this.subject.length < 2) {
        this.messageStatus = "error";

        const options = { title: "توجه", size: "sm" };
        this.$dialogs.alert("موضوع را به صورت کامل وارد کنید", options);
        return (this.messageText = "موضوع را به صورت کامل وارد کنید");
      } else if (this.body.length < 2) {
        this.messageStatus = "error";

        const options = { title: "توجه", size: "sm" };
        this.$dialogs.alert("نظر خود را به صورت کامل وارد کنید", options);
        return (this.messageText = "نظر خود را به صورت کامل وارد کنید");
      } else {
        this.messageStatus = "success";
        this.messageText = "پیام شما بلافاصله پس از دریافت پاسخ داده خواهد شد";
      }
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("subject", this.subject);
      formData.append("body", this.body);
      this.$axios.post("contact", formData).then(() => {
        const options = { title: "سپاس از شما", size: "sm" };
        this.$dialogs.alert("پیام شما دریافت شد", options);
        this.name = "";
        this.subject = "";
        this.email = "";
        this.body = "";
      });
    }
  },
  computed: {
    homeData() {
      return this.$root.homeData;
    }
  },
  metaInfo() {
    return {
      title: "تماس با ما ",
      meta: [
        {
          name: "description",
          content:
            "وبسایت دکتر صادقی فوق تخصص جراحی دندان و اولین ایرانی تولید کننده ارتودنسی های نامرئی"
        }
      ]
    };
  }
};
</script>

<style scoped>
/****============== Start contact =================****/
.contact-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 15px;
}
.contact-info {
  /*background-image: url("../assets/images/others/backRespMenu.jpg");*/
  background-size: 100% auto;
  /*filter: brightness(0.3);*/
  border: 1px solid var(--color-theme);
}
.contact-info > div {
  background-image: linear-gradient(to right, #fff, #ccc, #ccc);
}
/****============== End contact =================****/
@media screen and (max-width: 991px) {
  .contact-grid {
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
}
@media screen and (max-width: 767px) {
  .contact .contact-text {
    display: none;
  }
  .contact form input[type="submit"].w-25 {
    width: 100% !important;
  }
}
.error {
  color: red;
}
</style>
